var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileShareIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23943_51986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.156 5.77951L13.1953 0.628076C13.0335 0.460247 12.7854 0.407564 12.5695 0.494483C12.3528 0.582241 12.2108 0.792133 12.2108 1.02564V3.50605H12.0201C7.91725 3.50605 4.5791 6.8442 4.5791 10.947V12.0918C4.5791 12.3573 4.76608 12.5786 5.02474 12.639C5.0668 12.6496 5.10872 12.6542 5.15064 12.6542C5.36668 12.6542 5.5735 12.5275 5.67342 12.3284C6.74649 10.1815 8.90396 8.84823 11.3042 8.84823H12.2108V11.3285C12.2108 11.5622 12.3528 11.772 12.5695 11.859C12.784 11.9467 13.0335 11.8933 13.1953 11.7254L18.156 6.57394C18.3696 6.35189 18.3696 6.00239 18.156 5.77951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0267 18.7634H2.28952C1.02724 18.7634 0 17.7363 0 16.4739V5.78952C0 4.52724 1.02724 3.5 2.28952 3.5H4.57905C5.00107 3.5 5.34218 3.84111 5.34218 4.26313C5.34218 4.68515 5.00107 5.02626 4.57905 5.02626H2.28952C1.8682 5.02626 1.52626 5.3682 1.52626 5.78952V16.4739C1.52626 16.8952 1.8682 17.2371 2.28952 17.2371H16.0267C16.4479 17.2371 16.7898 16.8952 16.7898 16.4739V10.3686C16.7898 9.94656 17.1309 9.60531 17.5529 9.60531C17.9751 9.60531 18.3162 9.94656 18.3162 10.3686V16.4739C18.3162 17.7363 17.289 18.7634 16.0267 18.7634Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23943_51986"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.3164,
    height: 18.3164,
    fill: "white",
    transform: "translate(0 0.453125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileShareIcon);
export default __webpack_public_path__ + "static/media/FileShareIcon.162b73d199fe8f622f41a3cf0a815082.svg";
export { ForwardRef as ReactComponent };